import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Map from "./map";

const AddressContainer = styled.div`
    a{
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-decoration: none;
        color: #47566D;
        text-align: left;
    }
`;

class Address extends React.Component {
    constructor(props) {
        super(props);
    }

    getMapUrl(){
        const zoom = '13';
        return `https://www.google.com/maps/dir/?api=1&destination=${this.props.lat},${this.props.lng}&zoom=${zoom}`;
    }

    render() {
        return (
            <AddressContainer>
                <a href={this.getMapUrl()} target="_blank" rel="noreferrer">
                    <Map lng={this.props.lng} lat={this.props.lat}  />

                    <p>{this.props.address}</p>
                </a>
            </AddressContainer>
        )
    }
}

Address.propTypes = {
    address: PropTypes.string.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
};

export default Address;
